// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f908d559","453":"4d13a494","732":"39a0d2a3"}[chunkId] + ".chunk.js";
};